import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class UserStateService {
  private _serverCookies = '';
  private _platformId = '';

  constructor(
    private clientCookies: CookieService,
    @Inject('COOKIES') serverCookies: string,
    @Inject(PLATFORM_ID) platformId: string) {
    this._serverCookies = serverCookies;
    this._platformId = platformId;
  }

  public getItem(key: string): string {
    if (!key) {
      return null;
    }
    if (this.isBrowser) {
      return this.clientCookies.get(key);
    } else {
      if (this._serverCookies) {
        const ca = this._serverCookies.split(';');
        for (const c of ca) {
          let cs = '';
          while (c.charAt(0) === ' ') {
            cs = c.substring(1, c.length);
          }

          if (cs.indexOf(`${key}=`) === 0) {
            return c.substring(`${key}=`.length, c.length);
          }
        }
      }
      return null;
    }
  }

  public setItem(key, value, end?, path?, domain?, secure?) {
    path = path || '/';
    if (this.isBrowser) {
      this.clientCookies.set(key, value, end, path, domain, secure);
    } else {
      if (end && typeof (end) === 'number') {
        const date = new Date();
        date.setTime(date.getTime() + (end * 24 * 60 * 60 * 1000));
        end = date;
      }

      let expires = '';
      if (end && end.toGMTString) {
        expires = `; expires=${end.toGMTString()}`;
      }

      document.cookie = `${name}=${value}${expires}; path=${path}`;
    }
  }

  public hasItem(key): boolean {
    if (this.isBrowser) {
      return this.clientCookies.check(key);
    } else {
      return !!this.getItem(key);
    }
  }

  public removeItem(key, path?, domain?) {
    if (this.isBrowser) {
      this.clientCookies.delete(key, path || '/', domain);
    } else {
      if (this.hasItem(key)) {
        this.setItem(key, '', -1);
      }
    }
  }


  private get isBrowser(): boolean {
    return isPlatformBrowser(this._platformId);
  }
}
